import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  InvoiceSetupCreateHelp,
  ChargesCreateHelp,
  ChargesEditHelp,
  HistoryEditHelp,
  InvoiceSetupEditHelp,
} from "./InvoiceHelpComponents";

const useStyles = makeStyles(() => ({
  icon: {
    verticalAlign: "middle",
    display: "inline-flex",
  },
}));

export const InvoiceCreateHelp = (props) => {
  const classes = useStyles();
  const tabNames = props?.location?.pathname.split("/");
  const tab = tabNames?.length > 3 ? tabNames[3] : "";

  switch (tab) {
    case "":
      return <InvoiceSetupCreateHelp classes={classes} />;
    case "charges":
      return <ChargesCreateHelp classes={classes} />;
    default:
      return null;
  }
};

export const InvoiceEditHelp = (props) => {
  const classes = useStyles();
  const tabNames = props?.location?.pathname.split("/");
  const tab = tabNames?.length > 3 ? tabNames[3] : "";

  switch (tab) {
    case "":
      return <InvoiceSetupEditHelp classes={classes} />;
    case "charges":
      return <ChargesEditHelp classes={classes} />;
    case "historyLog":
      return <HistoryEditHelp classes={classes} />;
    default:
      return null;
  }
};
